export default __webpack_public_path__ + "static/media/fachada-concept.f87b9e17.png";